import gaTagTracking from './ga-tag-tracking';
import { events, actions, categories, settings, positions, dimensions, labels, names, affiliations } from './constants';
const analyticsUtils = {
  gaTagTracking,
  events,
  actions,
  categories,
  settings,
  positions,
  dimensions,
  labels,
  names,
  affiliations
};
export default analyticsUtils;